module.exports = __webpack_public_path__ + "static/flags/BA-82b53dc14944a3af534401747d996544.gif";